import React from 'react';

import styled from 'styled-components';
import { VerticalFlexContainer } from 'styles/common';

import { ArrowThickLeftIcon, ArrowThickRightIcon, PlusIcon2 } from 'constants/icons';
import theme from 'constants/theme';

import CircularOutlineIcon from 'uiToolkit/CircularOutlineIcon';
import { Typography7, Typography9 } from 'uiToolkit/Typography';

const CardWrapper = styled.div`
  height: 80px;
  width: 300px;
  background: ${(props) => props.theme.palette.background.paper};
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.palette.borders.blue};
  padding: 12px;
  position: relative;
  margin-top: 32px;
`;

const ExpandCollapseWrapper = styled.div`
  position: absolute;
  right: -32px;
  top: 28px;
`;

const OptionsWrapper = styled.div`
  position: absolute;
  right: -1px;
  bottom: -32px;
`;

const ExpandCollapseButton = ({ isExpanded, onClick }) => {
  const Icon = () => (isExpanded ? <ArrowThickLeftIcon size="fixed10px" /> : <ArrowThickRightIcon size="fixed10px" />);
  return <CircularOutlineIcon onClick={() => onClick(!isExpanded)} color="primary" icon={Icon} />;
};

const RootNode = ({ onObjectiveCreationClick, onExpandClick, isExpanded, enableObjectiveCreation = false }) => (
  <CardWrapper>
    <VerticalFlexContainer style={{ alignItems: 'center', justifyContent: 'center' }}>
      <Typography7 customColor={theme.palette.text.primaryBlue}>Objective Tree</Typography7>
      <Typography9 align="center" lineheight="15px" topGutter={0.5}>
        Create or view all your goals across objectives
      </Typography9>
    </VerticalFlexContainer>
    <ExpandCollapseWrapper>
      <ExpandCollapseButton isExpanded={isExpanded} onClick={onExpandClick} />
    </ExpandCollapseWrapper>
    <OptionsWrapper>
      {enableObjectiveCreation && (
        <CircularOutlineIcon onClick={onObjectiveCreationClick} color="primary" icon={PlusIcon2} />
      )}
    </OptionsWrapper>
  </CardWrapper>
);

export default RootNode;
